import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { guestGuard } from './auth/guards/guest.guard';
import { ApplyForJobComponent } from './apply-for-job/apply-for-job.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [guestGuard],
  },

  {
    path: 'apply-for-job',
    component: ApplyForJobComponent,
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./contact/contact.module').then((m) => m.ContactModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'translations',
    loadChildren: () =>
      import('./translations/translations.module').then(
        (m) => m.TranslationsModule
      ),
    // canActivate: [AuthGuard]
  },
  {
    path: 'success',
    loadChildren: () =>
      import('./shared/components/success-page//success-page.module').then(
        (m) => m.SuccessPageModule
      ),
  },
  {
    path: 'talent',
    loadChildren: () =>
      import('./talent/talent.module').then((m) => m.TalentModule),
    // canActivate: [AuthGuard],
  },
  {
    path: 'recruiter',
    loadChildren: () =>
      import('./recruiter/recruiter.module').then((m) => m.RecruiterModule),
    // canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
